import { render, staticRenderFns } from "./full-report.vue?vue&type=template&id=2d1b35ca&"
import script from "./full-report.vue?vue&type=script&lang=js&"
export * from "./full-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports